module.exports = __webpack_public_path__ + "media/entities/1203-8b7ab52f.png";